export const AppConfigTypes = {
  toogleDarkMode: "[AppConfigTypes] SignIn",
};
